import * as React from 'react'
import { useIubendaSnippetActivation } from '@repo/analytics/iubenda'

export function IubendaSnippet({
  id,
  src,
  children,
  purposes = '5',
  defer = false,
}: {
  id: string
  src?: string
  children?: string
  purposes?: string
  defer?: boolean
}) {
  React.useEffect(() => {
    if (document.querySelector(`#${CSS.escape(id)}`)) {
      return
    }

    // Iubenda replaces activated scripts, so register them outside React-owned DOM.
    const script = document.createElement('script')
    script.id = id
    script.type = 'text/plain'
    if (defer) {
      script.dataset.cfDefer = 'true'
    } else {
      script.className = '_iub_cs_activate'
    }
    script.dataset.iubPurposes = purposes
    if (src) {
      if (defer) {
        script.dataset.cfSrc = src
      } else {
        script.dataset.suppressedsrc = src
      }
    }
    if (children) {
      script.textContent = children
    }
    document.head.appendChild(script)
  }, [id, src, children, purposes, defer])

  useIubendaSnippetActivation()

  return null
}
